import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import * as Types from "./types";

export const employeeAllowanceListService = (
  params: Types.EmployeeAllowanceListRequest
) =>
  RestAPIClient.call<Types.EmployeeAllowanceListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const employeeAllowanceCreateService = (
  params: Types.EmployeeAllowanceCreateRequest
) =>
  RestAPIClient.call<Types.EmployeeAllowance>({
    method: HTTPRequestMethods.POST,
    url: Paths.Create,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const employeeAllowanceUpdateService = (
  params: Types.EmployeeAllowanceUpdateRequest
) =>
  RestAPIClient.call<Types.EmployeeAllowance>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update}/${params.id}`,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const employeeAllowanceDeleteService = (id: string) =>
  RestAPIClient.call<Types.EmployeeAllowance>({
    method: HTTPRequestMethods.DELETE,
    url: `${Paths.Update}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });

export const employeeAllowanceDetailService = (id: string) =>
  RestAPIClient.call<Types.EmployeeAllowance>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.Update}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });
